"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataFilter = void 0;
var React = __importStar(require("react"));
var hooks_1 = require("../../common/hooks");
var components_1 = require("../../components");
var models_1 = require("../../models");
var SelectionMenu_1 = require("../SelectionMenu");
var DataFilter = function (props) {
    var data = props.data, _a = props.filterFunction, filterFunction = _a === void 0 ? function (d, s) {
        return String(d).toLocaleLowerCase().includes(s);
    } : _a, filterLabel = props.filterLabel, onFilter = props.onFilter, _b = props.filterPlaceholder, filterPlaceholder = _b === void 0 ? "" : _b, otherProps = __rest(props, ["data", "filterFunction", "filterLabel", "onFilter", "filterPlaceholder"]);
    var _c = React.useState(""), filterValue = _c[0], setFilterValue = _c[1];
    // call the onFilter callback whenever the filterValue or the data changes.
    React.useEffect(function () {
        if (filterValue) {
            var newFilteredData = new models_1.Grouping("", data).filter(function (d) { return filterFunction((0, SelectionMenu_1.isDatumWithMetadata)(d) ? d[0] : d, filterValue); }, function (g) { return g.children.length > 0; });
            onFilter((newFilteredData && newFilteredData.children) || []);
        }
        else {
            onFilter(data);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, filterValue]);
    return (React.createElement("div", __assign({}, (0, hooks_1.useMergedProps)(otherProps, {
        _gkComponentIdentifier: "gk-data-filter",
    })),
        React.createElement(components_1.GKFormGroup, { className: "mb-0" },
            filterLabel && React.createElement(components_1.GKLabel, null, filterLabel),
            React.createElement("div", { className: "gk-input-icon-left" },
                React.createElement(components_1.GKIcon, { name: components_1.GKIconName.Search }),
                React.createElement(components_1.GKInput, { onChange: function (e) { return setFilterValue(e.target.value); }, onKeyUp: function (e) { return e.stopPropagation(); }, placeholder: filterPlaceholder, value: filterValue })))));
};
exports.DataFilter = DataFilter;
